import React, { ReactElement } from 'react';
import { FormattedMessage, MessageValue } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import ICONS from '../constants/icons';
import Icon from './Icon';

interface ITooltipWrapperProps extends ReactTooltip.Props {
    id: string;
    tooltipText: FormattedMessage.MessageDescriptor | string;
    children: ReactElement;
    disableTooltip?: boolean;
    value?: { [key: string]: MessageValue | JSX.Element };
    touchSize?: [number, number];
}

const PopupIconWrapper = styled.div`
    padding: 10px;
`;

const PopupTextWrapper = styled.div``;

const TooltipStyled = styled(ReactTooltip)`
    &.__react_component_tooltip {
        align-items: center;
        background-color: #ebf7fe;
        color: #006497;
        display: flex;
        max-width: 300px;

        &::after,
        &::before {
            display: none !important;
        }

        &.border {
            border-color: #c1e6fa;
        }

        &.show {
            opacity: 0.95;
        }
    }
`;

const TooltipChildrenWrapper = styled.div<Pick<ITooltipWrapperProps, 'touchSize'>>`
    display: flex;
    width: ${(props) => (props.touchSize ? props.touchSize[0] + 'px' : 'auto')};
    height: ${(props) => (props.touchSize ? props.touchSize[1] + 'px' : 'auto')};
    justify-content: center;
    align-items: center;
`;

export const TooltipWrapper = ({
    id,
    tooltipText,
    children,
    disableTooltip,
    value,
    touchSize,
    ...rest
}: ITooltipWrapperProps) => {
    if (disableTooltip) {
        return <TooltipChildrenWrapper touchSize={touchSize}>{children}</TooltipChildrenWrapper>;
    }

    const text = TranslationHelpers.isMessageDescriptor(tooltipText)
        ? TranslationHelpers.getFormattedMessage(tooltipText.id, value)
        : tooltipText;

    return (
        <React.Fragment>
            <TooltipStyled id={id} border={true} {...rest}>
                <PopupIconWrapper>
                    <Icon icon={ICONS.INFO} />
                </PopupIconWrapper>
                <PopupTextWrapper>{text}</PopupTextWrapper>
            </TooltipStyled>
            {/* NOTE: Temporary work around until react-tooltip release feature to allow tooltip on disabled buttons */}
            <TooltipChildrenWrapper data-for={id} data-tip={text} touchSize={touchSize}>
                {children}
            </TooltipChildrenWrapper>
            {/*{React.cloneElement(children, { 'data-for': id, 'data-tip': text })}*/}
        </React.Fragment>
    );
};
